import React, { useCallback, useEffect, useRef } from "react";
import styled from "styled-components";
import Header from "@/components/Header";
import DeclaimImg from './imgs/declaim@2x.png';
import MainBg from './imgs/main-bg@2x.png';

import BackPage from './imgs/back-page@2x.png'
import Awake from './imgs/awake@2x.png';
import Btn1 from './imgs/again-large@2x.png';
import Btn2 from './imgs/share@2x.png';

import { isStorm } from './stock';
import bwmodel from '@/config/bwmodel'
import { activityShareFriend, handleUploadTrace } from './stock'
import ShareModal from './components/share';

const Page4 = ({ next, playResultInfo, back }) => {

  const shareRef = useRef();

  const income = playResultInfo.incomeRatio ? Number(playResultInfo.incomeRatio * 100).toFixed(2) : 0

  useEffect(() => {
    handleUploadTrace('easter-egg', 'visitor');
  }, [])


  const handleShareClick = useCallback(() => {
    next();

    /** **/
    handleUploadTrace('share', 'click');
  }, []);

  const handlePlayAgain = () => {
    /** **/
    handleUploadTrace('easter-egg-once-again', 'click');

    if (shareRef.current) {
      shareRef.current.show()
    }
  }

  const handleShareFriend = () => {
    activityShareFriend(`${income}%`)
  }

  const handleShare = () => {
    const income = (playResultInfo.incomeRatio ? Number(playResultInfo.incomeRatio * 100).toFixed(2) : 0) + '%';
    activityShareFriend(income)
  }

  return (
    <Container>
      {isStorm && 
        <Header
          title="重生之股神模拟器"
          right={<img onClick={handleShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          leftClick={back}
          hideNaviBar
        />
      }
      <div className={`page-body ${!isStorm ? 'hide-header' : ''}`}>
        <div className="page-content">
          <img src={MainBg} className='main-bg' alt=''/>
          <img src={DeclaimImg} alt='' className="declaim-img" />
          <img src={DeclaimImg} alt='' className="declaim-img-footer" />
          <div className="awake-conent">
            <img alt="" src={Awake} className='awake-img'/>
            <img alt="" src={BackPage} onClick={back} className='back-page'/>
            
            <div className="btn-wrap">
              <img onClick={handleShareFriend} alt="" src={Btn2} className='option-img'/>
              <img onClick={handlePlayAgain}  alt="" src={Btn1} className='option-img'/>
            </div>
          </div>
        </div>
      </div>
      <ShareModal income={`${income}%`} ref={shareRef} onShareClick={handleShareClick}/>
    </Container>
  );
}

export default React.memo(Page4);

const Container = styled.div`
  .page-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .declaim-img {
    position: absolute;
    left: 0;
    top: 0;
  }
  .awake-conent {
    position: relative;
    width: 368px;
    height: 597px;
    margin: 0 auto;
    .awake-img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      right: 0;
      z-index: 1;
    }
    .back-page {
      width: 96.5px;
      height: 14.5px;
      position: absolute;
      top: 42px;
      left: 46px;
      z-index: 2;
    }
  }
  .btn-wrap {
    position: absolute;
    padding: 0 30px;
    box-sizing: border-box;
    left: 0;
    bottom: 54px;
    width: 100%;
    z-index: 3;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .option-img {
      width: 108.5px;
      height: 140px;
    }
  }

  .rating-img-wrap {
    bottom: 64px;
    .rating-img {
      width: 157.5px;
      height: 138.5px;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_31/page4.js